import { useParams } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import { OrderManagementPage } from '../../../components';
import { ChecklistDetails } from './ChecklistDetails';

export const ChecklistDetailsPage = () => {
  const { purchaseOrderId }: { purchaseOrderId: string } = useParams();
  const isMobile = useMediaQuery('(max-width: 960px)');

  return (
    <OrderManagementPage
      title={`Checklist Details #${purchaseOrderId}`}
      hasNoContentPadding={isMobile}
    >
      <ChecklistDetails queryId={purchaseOrderId} />
    </OrderManagementPage>
  );
};
